import React from 'react';

function ThankYou() {
  return (
    <div className="container mx-auto p-6 text-center">
      <h2 className="text-3xl mb-6">Thank You for Your Support!</h2>
      <p className="text-lg">Your contribution means a lot. We'll use it to improve and continue our work!</p>
    </div>
  );
}

export default ThankYou;
